import debounce from 'lodash/debounce';
const isIE = /Trident|MSIE|Edge/.test(window.navigator.userAgent);

function getBottom(el) {
    var rect = el.getBoundingClientRect();
    return window.pageYOffset + rect.top + rect.height;
}

export default {
    inserted(el, binding, vnode) {
        if (!isIE) {
            return;
        }
        el.style.position = 'relative';
        let doc = document.documentElement;
        let rect = el.getBoundingClientRect();
        let top = rect.top + window.pageYOffset;
        let onScroll = function() {
            let width = Math.max(doc.clientWidth, window.innerWidth || 0);
            if (width <= 640) {
                //responsive breakpoint hard-coded
                el.style.transform = 'none';
                return;
            }
            let scrollTop = window.pageYOffset;
            let parentBottom = getBottom(el.parentNode);
            if (scrollTop > top) {
                let newTop = scrollTop - top;
                newTop -= Math.max(
                    0,
                    top + newTop + rect.height - parentBottom
                );
                el.style.transform = `translateY(${newTop}px)`;
            } else {
                el.style.transform = 'none';
            }
        };
        vnode.data.__onScroll = debounce(onScroll, 100);
        document.addEventListener('scroll', onScroll);
    },
    unbind(el, binding, vnode) {
        let onScroll = vnode.data.__onScroll;
        document.removeEventListener('scroll', onScroll);
    }
};
